import React, { useState, useEffect } from "react";
import "./style.css";
import Carrusel from "../../components/Carrusel/Carrusel";
import { Link } from "react-router-dom";
import { FaMapMarkerAlt, FaWhatsapp } from 'react-icons/fa';
import API from "../../hooks/Fetchs";



const MostrarOptimo = ({ tipo = "" }) => {
  const [inmuebles, setInmuebles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const url = API.read

  useEffect(() => {
    const fetchInmuebles = async () => {
      try {
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error("Error al obtener los datos.");
        }
        const data = await response.json();
        setInmuebles(data);
        setLoading(false);
      } catch (err) {
        setError(err);
        setLoading(false);
      }
    };

    fetchInmuebles();
  }, [url]);

  if (loading) return <p className="text-center">Cargando propiedades...</p>;
  if (error) return <p className="text-center text-danger">Error: {error.message}</p>;

  const inmueblesFiltrados = tipo
    ? inmuebles.filter((inmueble) => 
        inmueble.tipo_inmueble?.toLowerCase() === tipo.toLowerCase()
      )
    : inmuebles;

  // Función para abrir Google Maps
  const abrirGoogleMaps = (inmueble) => {
    const latitud = inmueble.latitud;
    const longitud = inmueble.longitud;
    const ubicacion = inmueble.ubicacion;

    if (latitud && longitud) {
      // Si hay latitud y longitud, abrimos el mapa directamente en esas coordenadas
      window.open(`https://www.google.com/maps?q=${latitud},${longitud}`, "_blank");
    } else if (ubicacion && ubicacion.trim() !== "") {
      // Si no hay coordenadas, pero sí dirección, usamos la dirección
      const query = encodeURIComponent(ubicacion);
      window.open(`https://www.google.com/maps/search/?api=1&query=${query}`, "_blank");
    } else {
      alert("Ubicación no disponible para este inmueble.");
    }
  };


  return (
    <div className="container mt-5">
      {inmueblesFiltrados.length === 0 ? (
        <div className="alert alert-info text-center">
          No hay propiedades disponibles en esta categoría
        </div>
      ) : (
        <div className="row g-4">
          {inmueblesFiltrados.map((inmueble) => {
            const baseUrl = `${API.readimg}/${inmueble.id}`;
            
            // Obtener imágenes de portada válidas
            const imagenesPortada = [1]
              .map((num) => {
                const imgName = inmueble[`img_portada_${num}`];
                if (!imgName || imgName.toLowerCase() === "null") return null;
                const fileName = `img_portada_${num}.webp`;
                return `${baseUrl}/${fileName}`;
              })
              .filter(Boolean);

            // Acortar descripción
            const descripcionCorta = inmueble.descripcion 
              ? (inmueble.descripcion.length > 50 
                  ? `${inmueble.descripcion.substring(0, 50)}...` 
                  : inmueble.descripcion)
              : 'Descripción no disponible';

            return (
              <div key={inmueble.id} className="col-md-6 col-lg-4">
                <div className="card h-100 shadow-sm">
                  <div className="card-img-top" style={{ overflow: "hidden" }}>
                    {imagenesPortada.length > 0 ? (
                      <Carrusel 
                        images={imagenesPortada} 
                        className="mostrar "
                      />
                    ) : (
                      <img
                        src="/default-property.jpg"
                        alt="Imagen no disponible"
                        className="h-100 w-100"
                        loading="lazy"
                        style={{ objectFit: "contain" }}
                      />
                    )}
                  </div>

                  <div className="card-body d-flex flex-column">
                    <h3 className="h5 card-title text-primary mb-3">
                      {inmueble.direccion} - {inmueble.lugar}
                    </h3>

                    {/* Mostrar ubicación con función para abrir Google Maps */}
                    {(inmueble.ubicacion || (inmueble.latitud && inmueble.longitud)) && (
                      <div className="mb-2">
                        <button
                          onClick={() => abrirGoogleMaps(inmueble)}
                          className="text-decoration-none btn btn-link"
                        >
                          <FaMapMarkerAlt className="me-2 text-danger" />
                          <span className="text-muted">Ver ubicación en Google Maps</span>
                        </button>
                      </div>
                    )}

                    <p className="card-text mb-3 text-muted">
                      {descripcionCorta}
                    </p>

                    <div className="mt-auto">
                      <div className="d-grid gap-2">
                        <Link 
                          to={`/inmueble/${inmueble.id}/${inmueble.slug}`}
                          className="btn btn-primary"
                        >
                          Ver Detalles
                        </Link>
                        
                        <a
                          href={`https://wa.me/?text=Estoy interesado en la propiedad: ${inmueble.direccion} - ${inmueble.lugar}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="btn btn-success"
                        >
                          <FaWhatsapp className="me-2" />
                          Consultar por WhatsApp
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default MostrarOptimo;
